import SvgIcon from '../SvgIcon/SvgIcon';

function YouTubeIcon({ ...props }) {
  return (
    <SvgIcon {...props}>
      <path d="M17.19,5.47H6.5A3.47,3.47,0,0,0,3,8.92v6.16a3.48,3.48,0,0,0,3.5,3.46H17.19a3.48,3.48,0,0,0,3.5-3.46V8.92A3.47,3.47,0,0,0,17.19,5.47Zm-6.9,9.07V9.46L14.74,12Z" />
    </SvgIcon>
  );
}

export default YouTubeIcon;
